<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="会员ID：" prop="member_id">
                <span>{{model.member_id}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <span>{{model.cellphone}}</span>
            </el-form-item>
            <el-form-item label="链接地址：" prop="link">
                <span>{{model.link}}</span>
            </el-form-item>
            <el-form-item label="时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'kitLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                cellphone: '',
                link: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/kitlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>